export default {
  state: {
    da_map_for_stores: {},
    da_map_for_brands: {},
  },
  mutations: {
    SET_DA_MAP_FOR_STORES: (state, value) => (state.da_map_for_stores = value),
    SET_DA_MAP_FOR_BRANDS: (state, value) => (state.da_map_for_brands = value),
  },
  actions: {
    build_store_delivery_areas_map({ commit, getters }) {
      if (
        getters.all_store_delivery_areas_being_loaded == false &&
        getters.all_stores_being_loaded == false
      ) {
        var for_brands = {}
        var for_stores = {}
        var all_store_delivery_areas = getters.all_store_delivery_areas
        for (var area of all_store_delivery_areas) {
          if (for_stores[area.delivery_area] == undefined) {
            for_stores[area.delivery_area] = {}
          }
          if (for_brands[area.delivery_area] == undefined) {
            for_brands[area.delivery_area] = {}
          }
          var store = getters.find_store_by_main_id(area.store_id)
          if (store) {
            for_stores[area.delivery_area][area.store_id] = 1
            for_brands[area.delivery_area][store.brand_id] = 1
          }
        }
        commit('SET_DA_MAP_FOR_STORES', for_stores)
        commit('SET_DA_MAP_FOR_BRANDS', for_brands)
      }
    },
  },
  getters: {
    getDAMapForStores: (state) => state.da_map_for_stores,
    //   getDeliverableStoresForBrand: (state, getters) => (brand_id) =>{
    //     if (getters.currentDA.length) {
    //         var stores_filter = {}
    //         for (var area of getters.currentDA) {
    //             stores_filter = {...stores_filter, ...state.da_map_for_stores[area.value]}
    //         }
    //         return getters.all_stores.filter((store) => stores_filter[store._id] && store.brand_id == brand_id)
    //     }
    //     else
    //     {
    //         return getters.find_stores_by_brand_id(brand_id)
    //     }
    //   },
    getFilteredOffers: (state, getters) => {
      if (getters.domainBasedBrand) {
        return getters.all_brand_offers
      } else {
        var brands = getters.getFilteredBrands
        var brandsDict = brands.reduce((accum, brand) => {
          accum[brand._id] = 1
          return accum
        }, {})
        return getters.all_goorder_offers.filter((item) => {
          return (
            item.country == getters.selectedCountry && brandsDict[item.brand_id]
          )
        })
      }
    },
    getFilteredBrandsByOfferType: (state, getters) => (offer_type_id) => {
      var brands = getters.getFilteredBrands
      if (offer_type_id) {
        var offer_type = offer_type_id
          ? getters.all_goorder_types.find((item) => item.name == offer_type_id)
          : undefined
        brands = brands.filter((brand) => offer_type.brands.includes(brand._id))
      }
      return brands
    },
    getFilteredBrands: (state, getters) => {
      return getters.all_brands.filter((brand) => {
        var attribute_to_check = 'available_goorder'
        if (getters.domainBasedBrand) {
          if (brand.id != getters.domainBasedBrand) {
            return false
          }
          attribute_to_check = 'website'
        }
        var result = brand[attribute_to_check]
        if (result && getters.getSelectedDelivery) {
          result = brand.enabled_modules.includes(getters.getSelectedDelivery)
        }
        if (result && getters.getSelectedBusinessType) {
          result = brand.brand_business_type == getters.getSelectedBusinessType
        }
        if (result && getters.getSelectedKitchenType) {
          result =
            brand.kitchen_type &&
            brand.kitchen_type.includes(getters.getSelectedKitchenType)
        }
        if (result && getters.getSelectedPriceRange) {
          result = brand.brand_price_range == getters.getSelectedPriceRange.name
        }
        if (result && getters.getSearchTerm && getters.getSearchTerm.length) {
          result = brand.company_name
            .toLowerCase()
            .includes(getters.getSearchTerm)
        }
        // if (result && getters.currentDA.length > 0)
        // {
        //     result = false
        //     for(var area of getters.currentDA)
        //     {
        //         if (state.da_map_for_brands[area.value] && state.da_map_for_brands[area.value][brand._id]) {
        //             return true
        //         }
        //     }
        // }
        else {
          return false
        }
        return result
      })
    },
    brandWiseStores: (state, getters) => {
      let brandId = getters.getSelectedBrandId
      if (getters.domainBasedBrand) {
        brandId = getters.domainBasedBrand
      }
      if (brandId) {
        // return getters.getDeliverableStoresForBrand(brandId)
        return brandId
      } else {
        return []
      }
    },
  },
}
